import React from "react";
var Loading = function () {
    return (React.createElement("div", { className: "full-height-container" },
        React.createElement("img", { src: "https://dev-files.maatai.com/send-doc.gif", alt: "image-matilda-loader" })));
};
Loading.propTypes = {};
export default Loading;
